'use client'

import React from 'react'

import { useIntersection } from '@/hooks/useIntersection'

interface FadeInUpBoxProps {
  className?: string
  children: React.ReactNode
  threshold?: number
  delay?: number
}

const FadeInUpBox: React.FC<FadeInUpBoxProps> = ({
  className = '',
  children,
  threshold = 0.3,
  delay = 200,
}) => {
  const { elementRef, hasIntersected } = useIntersection({
    threshold,
    delay,
  })
  return (
    <div
      className={`${className} transition-all duration-1200 ease-in-out ${hasIntersected ? 'translate-y-0 opacity-100' : 'translate-y-16 opacity-0'}`}
      ref={elementRef}
    >
      {children}
    </div>
  )
}

export default FadeInUpBox
